module.exports = __webpack_public_path__ + "static/phone_call_1-3b1f383440b9b94e4dbd1ecc5e513e56.jpg";